import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './index.css';

ReactDOM.render(
  <App />,
  document.getElementById('root')
);

document.addEventListener("DOMContentLoaded", function(event){
	window.scrollTo(0,1);
});


// WEBPACK FOOTER //
// ./src/index.js